/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
import { ReactElement } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { iSummary } from '@interfaces/interfaces';
import styles from './Summary.module.scss';
import EditIcon from '../../images/edit.svg';

interface iProps {
  summaryFields: iSummary[];
}

const Summary = ({ summaryFields }: iProps): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <div className="vfH2">Check and confirm</div>
      <div className="subHeadingH3">Please review all details and your answers to questions below before continuing.</div>
      {summaryFields.map((section, index) => {
        if (section.title) {
          return (
            <div key={index} className={styles.section}>
              <div className={styles.heading}>
                <div className={styles.title}>{section.title}</div>
                <button
                  type="button"
                  className={styles.edit}
                  onClick={() => {
                    navigate(`${location.pathname.split('/').slice(0, -1).join('/')}${section.editLink}`);
                  }}>
                  <span className={styles.btnLabel}>Edit</span>
                  <img className={styles.iconContainer} src={EditIcon} alt="icon" />
                </button>
              </div>
              {section.fields.map((row, index2) => {
                if (row.length > 0) {
                  return (
                    <div className={styles.row} key={index2}>
                      {row.map((field, index3) => {
                        return (
                          <div className={styles.field} key={index3}>
                            <div className={styles.fieldTitle}>{field.title}</div>
                            <div className={styles.fieldValue}>{field.value}</div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }
                return <div key={index2} className={styles.hide} />;
              })}
            </div>
          );
        }
        return <div key={index} className={styles.hide} />;
      })}
    </>
  );
};

export default Summary;
